import { Navigate, useRoutes } from 'react-router-dom';
import GuardAuthRoutes from './features/auth/components/guard-auth-routes';
import GuardPrivateRoutes from './features/auth/components/guard-private-routes';
import GuardEmailVerified from './features/auth/components/guard-email-verified';
import MainLayer from './layout/app-main';
import LoginPage from './pages/login-page';
import RegisterPage from "@pages/register-page";
import EmailVerificationPage from "@pages/email-verification-page";
import GuardNotEmailVerified from "./features/auth/components/guard-not-email-verifies";
import ForgotPasswordPage from "@pages/forgot-password-page";
import PublicArticlePage from "@pages/public-article-page";
import PublicArticleAdditionalInfoPage from "@pages/public-article-additional-info";

const AppRoutes = () => {
    return useRoutes([
        {
            path: '/',
            element: <Navigate to="/app" />,
        },
        {
            path: '/login',
            element: (
                <GuardAuthRoutes>
                    <LoginPage />
                </GuardAuthRoutes>
            ),
        },
        {
            path: '/register',
            element: (
                <GuardAuthRoutes>
                    <RegisterPage />
                </GuardAuthRoutes>
            ),
        },
        {
            path: '/forgot-password',
            element: (
                <GuardAuthRoutes>
                    <ForgotPasswordPage />
                </GuardAuthRoutes>
            ),
        },
        {
            path: '/email-verification',
            element: (
                <GuardPrivateRoutes>
                    <GuardNotEmailVerified>
                        <EmailVerificationPage />
                    </GuardNotEmailVerified>
                </GuardPrivateRoutes>
            ),
        },
        {
            path: '/app/*',
            element: (
                <GuardPrivateRoutes>
                    <GuardEmailVerified>
                        <MainLayer />
                    </GuardEmailVerified>
                </GuardPrivateRoutes>
            ),
        },
        {
            path: '/article/:appId/:articleTitle',
            element: (
                <PublicArticlePage />
            ),
        },
        {
            path: '/article/visit-requirement',
            element: (
                <PublicArticleAdditionalInfoPage />
            ),
        },
    ]);
};

export default AppRoutes;
